import { WatchlistActions } from '@unistocks/features/watchlists/store/watchlist.slice';
import { Watchlist } from '@unistocks/features/watchlists/watchlist';
import { useWatchlistsGetQuery } from '@unistocks/proxy/axios-client/WatchlistsQuery';
import { useAppDispatch } from '@unistocks/shared/hooks/redux-hooks';
import { t } from '@unistocks/shared/localization/index.ts';
import { HasId } from '@unistocks/types/has-id';
import { useFocusEffect, useLocalSearchParams, useNavigation } from 'expo-router';
import Head from 'expo-router/head';
import { useCallback } from 'react';

export default function WatchlistScreen() {
  const navigation = useNavigation();
  const dispatch = useAppDispatch();
  const { id } = useLocalSearchParams<HasId>();
  const { data: watchlist, isSuccess } = useWatchlistsGetQuery({ id });

  useFocusEffect(
    useCallback(() => {
      if (watchlist) {
        navigation.setOptions({ title: watchlist.name });
        dispatch(WatchlistActions.setSelectedWatchlistId(watchlist.id));
      }
    }, [dispatch, navigation, watchlist])
  );

  let title = t('::Watchlist');
  if (isSuccess) {
    title = `${watchlist.name} | ${title}`;
  }

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <Watchlist id={id} />
    </>
  );
}
